// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HttpError_wrapper__2imJI","innerWrapper":"HttpError_innerWrapper__3CyK9","heading":"HttpError_heading__2JwTg","message":"HttpError_message__1pDL2"};